import { render, staticRenderFns } from "./secret.vue?vue&type=template&id=b0a61ca2&scoped=true&"
import script from "./secret.vue?vue&type=script&lang=js&"
export * from "./secret.vue?vue&type=script&lang=js&"
import style0 from "./secret.vue?vue&type=style&index=0&id=b0a61ca2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0a61ca2",
  null
  
)

export default component.exports